import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Intro.css";
import personality from "../../../img/test-images/intro-images/personality-intro.svg";
import clock from "../../../img/test-images/clock.svg";

function Intro() {
  return (
    <div className="intro-div">
      <Container className="intro-container">
        <Row>
          <Col md={6}>
            <img src={personality} alt="personality-assessment" />
          </Col>
          <Col md={6}>
            <p>
              Personality, in simple terms, encompasses your characteristics
              that make you unique and help differentiate you from others. Your
              personality can be at times understood by your behavior and way of
              thinking. There are 5 factors that have been widely accepted as
              impacting one's personality.
              <br />
              The test you are about to take will measure your personality on
              the basis of these 5 factors. Click on the button below to proceed
              to the questions.
            </p>
            <div className="test-time">
              <img src={clock} alt="time" />3 - 5 minutes
            </div>
            <Button
              variant="secondary"
              size="lg"
              href="/selfevaluation/personality-assessment/quiz"
            >
              Proceed
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Intro;
